/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';

import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import api from '~/services/api';

import { IFormSMTP } from './types';
import ToggleDefault from '~/components/ToggleDefault';
import { CancelButton, ConfirmButton } from '~/components/Buttons';
import { useForm } from 'react-hook-form';
import { InputNumber, InputText } from '~/components/NovosInputs';

interface FormProps {
  show: boolean;
  handleShow: (value: boolean) => void;
  handleTex: (value: any) => void;
  id: number | undefined;
}

const ModalSmtp: React.FC<FormProps> = ({
  show,
  handleShow,
  handleTex,
  id,
}) => {
  const [isUpdate, setIsUpdate] = useState(false);
  // const [initInicializado, setInitInicializado] = useState(false);

  const [formSmtp, setFormSmtp] = useState<IFormSMTP>({
    des_smtp: {
      value: '',
      isInvalid: true,
      isRequired: true,
      invalidLabel: '',
    },
    num_porta: {
      value: 0,
      isInvalid: true,
      isRequired: true,
      invalidLabel: '',
    },
    flg_conexao_ssl: {
      value: false,
      isInvalid: false,
      isRequired: false,
      invalidLabel: '',
    },
  });

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      getSmtp();
      setIsUpdate(true);
    } else {
      clearForm();
      setIsUpdate(false);
    }
  }, [show]);

  async function getSmtp() {
    const res = await api.get(`/smtp/${id}`);
    const { data } = res.data;
    const { des_smtp, num_porta, flg_conexao_ssl } = data;

    setValue('des_smtp', des_smtp);
    setValue('num_porta', num_porta);

    setFormSmtp({
      des_smtp: {
        ...formSmtp.des_smtp,
        value: des_smtp,
        isInvalid: false,
      },
      num_porta: {
        ...formSmtp.num_porta,
        value: num_porta,
        isInvalid: false,
      },
      flg_conexao_ssl: {
        ...formSmtp.flg_conexao_ssl,
        value: flg_conexao_ssl,
      },
    });
  }

  function validaFormSmtp(inputs: IFormSMTP): boolean {
    for (let i = 0; i < Object.keys(inputs).length; i++) {
      if (
        formSmtp[Object.keys(inputs)[i] as keyof IFormSMTP].isRequired &&
        formSmtp[Object.keys(inputs)[i] as keyof IFormSMTP].isInvalid
      ) {
        return true;
      }
    }
    return false;
  }

  async function onSubmit() {
    if (validaFormSmtp(formSmtp)) {
      toast.warning('Há informações pendentes.');
      return;
    }

    if (Number.isNaN(formSmtp.num_porta.value)) {
      return toast.warning('Número da porta deve ser diferente de zero');
    }

    const upsert = {
      des_smtp: formSmtp.des_smtp.value,
      num_porta: formSmtp.num_porta.value,
      flg_conexao_ssl: formSmtp.flg_conexao_ssl.value,
    };
    if (!isUpdate) {
      const res = await api.post('/smtp', upsert);
      const { message } = res.data;
      handleTex(upsert);
      handleShow(false);
      return toast.success(message);
    }
    const res = await api.put(`/smtp/${id}`, upsert);
    const { message } = res.data;
    handleShow(false);
    return toast.success(message);
  }

  function clearForm() {
    setValue('des_smtp', '');
    setValue('num_porta', '');

    setFormSmtp({
      des_smtp: {
        value: '',
        isInvalid: true,
        isRequired: true,
        invalidLabel: '',
      },
      num_porta: {
        value: 0,
        isInvalid: true,
        isRequired: true,
        invalidLabel: '',
      },
      flg_conexao_ssl: {
        value: false,
        isInvalid: false,
        isRequired: false,
        invalidLabel: '',
      },
    });
  }

  function onCancel() {
    clearForm();
    handleShow(false);
  }

  useEffect(() => {
    if (show) {
      const inputSMTP: HTMLInputElement | null =
        document.querySelector('[name="des_smtp"]');

      if (inputSMTP) {
        inputSMTP.focus();
        inputSMTP.click();

        if (isUpdate) inputSMTP.select();
      }
    }
  }, [show]);

  return (
    <>
      {show && (
        <Modal
          show={show}
          onHide={() => handleShow(false)}
          className="modal-fade absolute inset-0 overflow-auto bg-gray-50"
          id="modalEmailServidorEntrada"
          centered
          size="lg"
        >
          <Modal.Header>
            <Modal.Title id="modalEmailServidorEntrada">
              {!isUpdate ? 'Cadastrar' : 'Editar'} Servidor SMTP
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <InputText
                  label="SMTP"
                  placeholder=""
                  maxLength={100}
                  control={control}
                  register={register}
                  name="des_smtp"
                  isError={!!errors.des_smtp}
                  onInput={(ev: any) => {
                    const { value } = ev.target;

                    setValue('des_smtp', value);

                    setFormSmtp({
                      ...formSmtp,
                      des_smtp: {
                        ...formSmtp.des_smtp,
                        value,
                        isInvalid: value === '',
                      },
                    });
                  }}
                />
              </div>
              <div className="col-sm-12 col-md-2">
                <InputNumber
                  label="Porta"
                  placeholder=""
                  maxLength={100}
                  min={1}
                  max={65536}
                  control={control}
                  register={register}
                  name="num_porta"
                  isError={!!errors.num_porta}
                  onInput={(ev: any) => {
                    const { value } = ev.target;

                    setValue('num_porta', value);

                    if (value >= 1 && value <= 65536) {
                      setFormSmtp({
                        ...formSmtp,
                        num_porta: {
                          ...formSmtp.num_porta,
                          value,
                          isInvalid: false,
                        },
                      });
                    }
                  }}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="mt-3">
            <ToggleDefault
              labelText="Utilizar Conexão Segura SSL/TLS"
              setChecked={formSmtp.flg_conexao_ssl.value}
              onSwitch={() =>
                setFormSmtp({
                  ...formSmtp,
                  flg_conexao_ssl: {
                    ...formSmtp.flg_conexao_ssl,
                    value: !formSmtp.flg_conexao_ssl.value,
                  },
                })
              }
            />
            <div className="d-flex col justify-content-end">
              <ConfirmButton onClick={() => onSubmit()}>
                Confirmar
              </ConfirmButton>
              <CancelButton onClick={() => onCancel()}>Cancelar</CancelButton>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default ModalSmtp;
